(() => {
  const MARKERS = Object.freeze({
    socks: 'BUNDLE-Sweater+Socks',
    candle: 'BUNDLE-Sweater+Candle',
    mega: 'BUNDLE-Mega',
  });

  const markerValues = Object.values(MARKERS);

  function resolveSelection(key, config) {
    if (key === 'sweater') {
      return {
        variantId: String(config.sourceVariantId || ''),
        marker: '',
        available: Boolean(config.sourceVariantId && config.sourceAvailable),
        isBundle: false,
      };
    }

    const bundle = config.bundles && config.bundles[key];
    return {
      variantId: String((bundle && bundle.variantId) || ''),
      marker: (bundle && bundle.marker) || '',
      available: Boolean(bundle && bundle.variantId && bundle.available),
      isBundle: true,
    };
  }

  function classifyMedia(alt, activeMarker) {
    const value = String(alt || '');
    if (activeMarker && value.includes(activeMarker)) return 0;
    if (markerValues.some((candidate) => value.includes(candidate))) return 2;
    return 1;
  }

  function calculateSavings(compareAtPrice, price) {
    const savings = Number(compareAtPrice || 0) - Number(price || 0);
    return savings > 0 ? savings : 0;
  }

  function resolvePriceView(data) {
    const price = Number(data.price || 0);
    const compareAtPrice = Number(data.compareAtPrice || 0);
    const onSale = compareAtPrice > price;
    return {
      price: data.formattedPrice || '',
      compareAtPrice: onSale ? data.formattedCompareAtPrice || '' : '',
      onSale,
    };
  }

  function resolveBuyNowUrl(variantId, root = '/') {
    const id = String(variantId || '').trim();
    if (!/^\d+$/.test(id)) return '';
    const base = String(root || '/');
    const normalizedRoot = base.endsWith('/') ? base : `${base}/`;
    return `${normalizedRoot}cart/${id}:1`;
  }

  function mediaAlt(item) {
    const image = item.querySelector && item.querySelector('img');
    return image ? image.getAttribute('alt') || '' : '';
  }

  const STICKY_IMAGE_ATTRIBUTES = ['src', 'srcset', 'sizes', 'width', 'height', 'alt'];

  function syncImageAttributes(sourceImage, targetImage) {
    if (!sourceImage || !targetImage) return false;
    STICKY_IMAGE_ATTRIBUTES.forEach((attribute) => {
      const value = sourceImage.getAttribute(attribute);
      if (value === null) targetImage.removeAttribute(attribute);
      else targetImage.setAttribute(attribute, value);
    });
    return true;
  }

  function updateStickyMedia(section, sectionId) {
    const sourceImage = section && section.querySelector('.js-product-slideshow-item:not([hidden]) img');
    const targetImage = document.querySelector(`#productStickyInfo-${sectionId} .js-product-sticky-info-media img`);
    return syncImageAttributes(sourceImage, targetImage);
  }

  function updateMediaContainer(container, itemSelector, activeMarker) {
    if (!container) return;
    const items = Array.from(container.querySelectorAll(`:scope > ${itemSelector}`));
    items.forEach((item, index) => {
      if (!item.dataset.holidayOriginalOrder) item.dataset.holidayOriginalOrder = String(index + 1);
    });
    items
      .sort((left, right) => {
        const leftClass = classifyMedia(mediaAlt(left), activeMarker);
        const rightClass = classifyMedia(mediaAlt(right), activeMarker);
        if (leftClass !== rightClass) return leftClass - rightClass;
        return Number(left.dataset.holidayOriginalOrder) - Number(right.dataset.holidayOriginalOrder);
      })
      .forEach((item) => {
        const hidden = classifyMedia(mediaAlt(item), activeMarker) === 2;
        item.toggleAttribute('hidden', hidden);
        item.classList.toggle('holiday-bundle-media-hidden', hidden);
        item.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        container.appendChild(item);
      });
  }

  function updateGallery(section, sectionId, activeMarker) {
    updateMediaContainer(section.querySelector('.js-product-slideshow'), '.js-product-slideshow-item', activeMarker);
    updateMediaContainer(section.querySelector('.product-slideshow__thumbs'), '.js-product-slideshow-thumb', activeMarker);

    const template = document.getElementById(`productGallery-${sectionId}`);
    if (template && template.content) {
      updateMediaContainer(template.content.querySelector('sht-gallery-slides'), '.js-gallery-slide', activeMarker);
      updateMediaContainer(template.content.querySelector('.horizontal-carousel'), '[data-media-target-id]', activeMarker);
    }

    const liveSlides = document.getElementById(`zoomContainer-${sectionId}`);
    if (liveSlides) {
      updateMediaContainer(liveSlides, '.js-gallery-slide', activeMarker);
      const liveGallery = liveSlides.closest('sht-gallery');
      updateMediaContainer(liveGallery && liveGallery.querySelector('.horizontal-carousel'), '[data-media-target-id]', activeMarker);
    }

    const firstVisibleThumb = section.querySelector('.js-product-slideshow-thumb:not([hidden]) button');
    if (firstVisibleThumb) firstVisibleThumb.click();
    window.dispatchEvent(new Event('resize'));
  }

  function resetMediaContainer(container, itemSelector) {
    if (!container) return;
    Array.from(container.querySelectorAll(`:scope > ${itemSelector}`))
      .sort((left, right) => Number(left.dataset.holidayOriginalOrder || 0) - Number(right.dataset.holidayOriginalOrder || 0))
      .forEach((item) => {
        item.removeAttribute('hidden');
        item.removeAttribute('aria-hidden');
        item.classList.remove('holiday-bundle-media-hidden');
        container.appendChild(item);
      });
  }

  function resetGallery(section, sectionId) {
    resetMediaContainer(section.querySelector('.js-product-slideshow'), '.js-product-slideshow-item');
    resetMediaContainer(section.querySelector('.product-slideshow__thumbs'), '.js-product-slideshow-thumb');

    const template = document.getElementById(`productGallery-${sectionId}`);
    if (template && template.content) {
      resetMediaContainer(template.content.querySelector('sht-gallery-slides'), '.js-gallery-slide');
      resetMediaContainer(template.content.querySelector('.horizontal-carousel'), '[data-media-target-id]');
    }

    const liveSlides = document.getElementById(`zoomContainer-${sectionId}`);
    if (liveSlides) {
      resetMediaContainer(liveSlides, '.js-gallery-slide');
      const liveGallery = liveSlides.closest('sht-gallery');
      resetMediaContainer(liveGallery && liveGallery.querySelector('.horizontal-carousel'), '[data-media-target-id]');
    }

    const firstThumb = section.querySelector('.js-product-slideshow-thumb button');
    if (firstThumb) firstThumb.click();
    window.dispatchEvent(new Event('resize'));
  }

  function updatePriceContainer(price, view) {
    if (!price) return;
    const regular = price.querySelector('.price__regular');
    const sale = price.querySelector('.price__sale');
    const regularValue = regular && regular.querySelector('.price-item--last');
    const saleValue = sale && sale.querySelector('.price-item--last');
    const compareValue = sale && sale.querySelector('s.price-item--regular');

    if (regularValue) regularValue.textContent = view.price;
    if (saleValue) saleValue.textContent = view.price;
    if (compareValue) compareValue.textContent = view.compareAtPrice;

    if (regular) {
      regular.classList.toggle('d-none', view.onSale);
      regular.classList.toggle('d-block', !view.onSale);
    }
    if (sale) {
      sale.classList.toggle('d-none', !view.onSale);
      sale.classList.toggle('d-flex', view.onSale);
    }
  }

  function updateProductPrice(section, view) {
    updatePriceContainer(section.querySelector('.js-product-price .price'), view);
  }

  function updateStickyPrice(sectionId, view) {
    const stickyPrice = document.querySelector(`#productStickyInfo-${sectionId} .js-product-sticky-info-price .price`);
    updatePriceContainer(stickyPrice, view);
  }

  const BaseHTMLElement = typeof HTMLElement === 'undefined' ? class {} : HTMLElement;

  class HolidaySweaterBundleSelector extends BaseHTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.section = this.closest('.js-main-product');
      if (!this.section) return;

      this.dataset.initialized = 'true';
      this.form = this.section.querySelector('.js-main-product-form');
      this.variantInput = this.form && this.form.querySelector('input[name="id"]');
      this.radios = Array.from(this.querySelectorAll('input[name="holiday_bundle_option"]'));
      this.submitButton = this.querySelector('[data-holiday-bundle-submit]');
      this.buyNowButton = this.querySelector('[data-holiday-bundle-buy-now]');
      this.sourceVariantId = this.dataset.sourceVariantId;
      this.sourceAvailable = this.dataset.sourceAvailable === 'true';
      this.sourceRadio = this.querySelector('input[name="holiday_bundle_option"][value="sweater"]');
      this.mainSectionId = this.section.id;
      this.stickyRoot = document.querySelector(`#productStickyInfo-${this.mainSectionId}`);
      this.stickyButton = this.stickyRoot && this.stickyRoot.querySelector('[type="submit"]');
      this.stickyVariantInput = this.stickyRoot && this.stickyRoot.querySelector('input[name="id"]');

      if (!this.form || !this.variantInput || !this.submitButton || !this.buyNowButton) return;

      this.section.classList.add('holiday-bundle-enabled');
      this.variantInput.disabled = false;
      this.addEventListener('change', this.handleChange.bind(this));
      this.submitButton.addEventListener('click', () => {
        if (!this.submitButton.disabled) this.form.requestSubmit();
      });
      this.buyNowButton.addEventListener('click', () => {
        if (this.buyNowButton.disabled) return;
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const checkoutUrl = resolveBuyNowUrl(this.variantInput.value, root);
        if (checkoutUrl) window.location.assign(checkoutUrl);
      });
      this.update();
    }

    disconnectedCallback() {
      if (this.dataset.initialized === 'true') this.restoreState();
    }

    restoreState() {
      if (!this.section || !this.variantInput) return;
      this.section.classList.remove('holiday-bundle-enabled');
      this.variantInput.value = this.sourceVariantId;
      if (this.stickyVariantInput) this.stickyVariantInput.value = this.sourceVariantId;
      if (this.stickyButton) {
        this.stickyButton.disabled = !this.sourceAvailable;
        this.stickyButton.setAttribute('aria-disabled', this.sourceAvailable ? 'false' : 'true');
      }
      if (this.sourceRadio) {
        const sourcePriceView = resolvePriceView(this.sourceRadio.dataset);
        updateProductPrice(this.section, sourcePriceView);
        updateStickyPrice(this.mainSectionId, sourcePriceView);
      }
      resetGallery(this.section, this.mainSectionId);
      updateStickyMedia(this.section, this.mainSectionId);
    }

    config() {
      const bundles = {};
      this.radios.forEach((radio) => {
        if (radio.value === 'sweater') return;
        bundles[radio.value] = {
          variantId: radio.dataset.variantId,
          marker: radio.dataset.mediaMarker,
          available: radio.dataset.available === 'true',
        };
      });
      return {
        sourceVariantId: this.sourceVariantId,
        sourceAvailable: this.sourceAvailable,
        bundles,
      };
    }

    handleChange(event) {
      if (event.target.matches('input[name="holiday_bundle_option"]')) this.update();
    }

    update() {
      const checked = this.querySelector('input[name="holiday_bundle_option"]:checked');
      if (!checked) return;
      const selection = resolveSelection(checked.value, this.config());
      this.variantInput.value = selection.variantId;
      if (this.stickyVariantInput) this.stickyVariantInput.value = selection.variantId;
      this.submitButton.disabled = !selection.available;
      this.submitButton.setAttribute('aria-disabled', selection.available ? 'false' : 'true');
      this.buyNowButton.disabled = !selection.available;
      this.buyNowButton.setAttribute('aria-disabled', selection.available ? 'false' : 'true');
      if (this.stickyButton) {
        this.stickyButton.disabled = !selection.available;
        this.stickyButton.setAttribute('aria-disabled', selection.available ? 'false' : 'true');
      }
      this.submitButton.textContent = selection.isBundle
        ? this.dataset.bundleButtonLabel
        : this.dataset.sweaterButtonLabel;
      if (this.stickyButton) {
        const stickyLabel = this.stickyButton.querySelector('.js-product-form-submit-btn-text');
        if (stickyLabel) stickyLabel.textContent = this.submitButton.textContent;
      }
      const priceView = resolvePriceView(checked.dataset);
      updateProductPrice(this.section, priceView);
      updateStickyPrice(this.mainSectionId, priceView);
      updateGallery(this.section, this.mainSectionId, selection.marker);
      updateStickyMedia(this.section, this.mainSectionId);
      this.dispatchEvent(new CustomEvent('holiday-bundle:change', {
        bubbles: true,
        detail: { key: checked.value, ...selection },
      }));
    }
  }

  class HolidaySweaterBundleSelectorMount extends BaseHTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.template = this.querySelector('template');
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
      this.mountSelector();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      this.removeMountedSelector();
    }

    removeMountedSelector() {
      document.querySelectorAll('[data-holiday-selector-owner]').forEach((selector) => {
        if (selector.dataset.holidaySelectorOwner === this.dataset.ownerId) selector.remove();
      });
    }

    mountSelector() {
      if (!this.template) return;
      const mainSection = document.querySelector('.js-main-product');
      const buyButtons = mainSection && mainSection.querySelector('.product__block-buy_buttons');
      const source = this.template.content.querySelector('holiday-sweater-bundle-selector');
      if (!buyButtons || !source) return;
      this.removeMountedSelector();
      const selector = source.cloneNode(true);
      selector.dataset.holidaySelectorOwner = this.dataset.ownerId;
      buyButtons.before(selector);
    }

    handleSectionLoad(event) {
      const loadedSection = event.target;
      if (loadedSection.matches('.js-main-product') || loadedSection.querySelector('.js-main-product')) {
        queueMicrotask(() => this.mountSelector());
      }
    }
  }

  if (typeof window !== 'undefined' && window.customElements && !window.customElements.get('holiday-sweater-bundle-selector-mount')) {
    window.customElements.define('holiday-sweater-bundle-selector-mount', HolidaySweaterBundleSelectorMount);
  }

  if (typeof window !== 'undefined' && window.customElements && !window.customElements.get('holiday-sweater-bundle-selector')) {
    window.customElements.define('holiday-sweater-bundle-selector', HolidaySweaterBundleSelector);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      MARKERS,
      resolveSelection,
      classifyMedia,
      calculateSavings,
      resolvePriceView,
      resolveBuyNowUrl,
      syncImageAttributes,
      HolidaySweaterBundleSelector,
    };
  }
})();
